import { defineMessages } from 'react-intl';

export const trackingHistorySectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Tracking History',
    id: 'I03VtX',
    description: 'Title of the tracking history card in the freight details view',
  },
  stepPendingPickup: {
    defaultMessage: 'Pending Pickup',
    id: 'xri9RQ',
    description: 'First tracking stepper step, before the carrier has picked up the shipment',
  },
  stepInTransit: {
    defaultMessage: 'In Transit',
    id: 'FkrHQO',
    description: 'Second tracking stepper step, while the shipment is moving',
  },
  stepOutForDelivery: {
    defaultMessage: 'Out for Delivery',
    id: 'wUub64',
    description: 'Third tracking stepper step, while the shipment is out for final delivery',
  },
  stepDelivered: {
    defaultMessage: 'Delivered',
    id: '1oYiWg',
    description: 'Final tracking stepper step, after the shipment has been delivered',
  },
  proNumberLabel: {
    defaultMessage: 'PRO Number',
    id: 'bGWaQH',
    description: 'Label for the carrier PRO number tracking link',
  },
  updatesTitle: {
    defaultMessage: 'Updates',
    id: 'rWd2a9',
    description: 'Title of the accordion listing tracking update events',
  },
  updatedBy: {
    defaultMessage: 'Updated by {name}',
    id: '/elJWu',
    description: 'Sub-line on a tracking update event naming the party that reported it',
  },
  lastUpdated: {
    defaultMessage: 'Updated: {date}',
    id: 'qyMe6p',
    description: 'Line showing the timestamp of the most recent carrier tracking event',
  },
  statusUnknown: {
    defaultMessage: 'Unknown',
    id: 'qB9rlM',
    description: 'Freight tracking status label: status not recognized',
  },
  statusCreated: {
    defaultMessage: 'Created',
    id: 'yCvitI',
    description: 'Freight tracking status label: shipment record created',
  },
  statusPendingPickup: {
    defaultMessage: 'Pending Pickup',
    id: 'npSixn',
    description: 'Freight tracking status label: awaiting carrier pickup',
  },
  statusDispatched: {
    defaultMessage: 'Dispatched',
    id: 'W2slw8',
    description: 'Freight tracking status label: carrier dispatched',
  },
  statusInRouteToPickup: {
    defaultMessage: 'In Route to Pickup',
    id: 'HC56AW',
    description: 'Freight tracking status label: carrier en route to pickup location',
  },
  statusAtPickup: {
    defaultMessage: 'At Pickup',
    id: '5/fvI7',
    description: 'Freight tracking status label: carrier at the pickup location',
  },
  statusInTransit: {
    defaultMessage: 'In Transit',
    id: 'CnTNNg',
    description: 'Freight tracking status label: shipment moving between terminals',
  },
  statusOutForDelivery: {
    defaultMessage: 'Out for Delivery',
    id: '2WXgTy',
    description: 'Freight tracking status label: shipment out for final delivery',
  },
  statusAtDelivery: {
    defaultMessage: 'At Delivery',
    id: 'gUYFT0',
    description: 'Freight tracking status label: carrier at the delivery location',
  },
  statusDelivered: {
    defaultMessage: 'Delivered',
    id: 'SLsWuH',
    description: 'Freight tracking status label: shipment delivered',
  },
  statusException: {
    defaultMessage: 'Exception',
    id: 'Shz6PG',
    description: 'Freight tracking status label: exception or problem with delivery',
  },
  statusVoided: {
    defaultMessage: 'Voided',
    id: 'pAEueX',
    description: 'Freight tracking status label: shipment voided',
  },
});
